<template>
  <v-flex xs12 sm12 md12 lg12 xl12>
    <Navbar></Navbar>
    <v-container class="">

      <v-layout row wrap>
        <v-flex sm4 md4 lg3  class="pl-1 ml-4 pt-5" >
          <v-card style="background-color:#B22F4A">
            <v-card-title>
              <span class="titlevideos" style="color:white; font-family:Poppins;  font-weight:600">VIDEOS</span>
            </v-card-title>
          </v-card>
        </v-flex>
            
        <v-flex md1 class="pt-5" >
          <v-card flat style="background-color:#D6D6D6">
            <img src="videos.png"  style="position:absolute;margin-left:-30px; margin-top:-2px" />
          </v-card>
        </v-flex>
            
        <v-spacer></v-spacer>
        <v-flex xs12 sm4 md4 lg6>
          <v-text-field 
            class="pt-2 mt-4 pa-3 hidden-sm-and-md" 
            solo  
            label="Buscar Video"  
            v-model="searchvideo" 
            prepend-inner-icon="search"
            style="width:75%;" >
          </v-text-field>
        </v-flex>  
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 sm6 md6 lg6 v-for="video in filterVideos" :key="video.title">
          <v-card flat class=" pa-4 " style="background-color:#D6D6D6" >
            <v-layout row wrap>
              <v-flex xs12 md12>
              <!--<v-layout :class="`actividad ${capacitacion.actividad}`">-->
                <v-card-title class="temavideo">
                  <div class="text-xs-center">
                    <span>{{video.title}}</span>
                  </div>
                </v-card-title>
              </v-flex>
            </v-layout>
            
            <v-img :src="video.img" width="100%">
              <div class="center">
                <Reproductor2 :capacitacion="video">
                </Reproductor2>
              </div>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
  
    </v-container>
  </v-flex>
</template>

<script>
  import Navbar from "@/components/Navbar.vue"
  import Reproductor2 from "@/components/ReproductorVideos.vue"
  
 
  export default {
   

    components:{
       Navbar,Reproductor2
     },
    data(){
      return{
        searchvideo:"",
        dialog:false,
       videos:[
          
          {tema:"1",title:"Lalabumers en Acción",img:"lalabumers_en_accion.png",url:"https://www.lalabumapp.com/descargas/videos/lalabumers_en_accion.mp4",namedownload:"video_lalabumers_en_accion"},
          {tema:"2",title:"Soy un Lalabumer",img:"soy_un_lalabumer.png",url:"https://www.lalabumapp.com/descargas/videos/soy_un_lalabumer.mp4"},
          {tema:"3",title:"Mis amigos Lalabumers",img:"mis_amigos_lalabumers.png",url:"https://www.lalabumapp.com/descargas/videos/mis_amigos_lalabumers.mp4"},
          {tema:"4",title:"Una solución Lalabum",img:"solucion_lalabum.png",url:"https://www.lalabumapp.com/descargas/videos/una_solucion_lalabum.mp4"},
          {tema:"5",title:"Buen día Lalabumer",img:"buen_dia_lalabumer.png",url:"https://www.lalabumapp.com/descargas/videos/buen_dia_lalabumer.mp4"},
          {tema:"6",title:"Me cuido como Lalabumer",img:"me_cuido_como_lalabumer.png",url:"https://www.lalabumapp.com/descargas/videos/me_cuido_como_lalabumer.mp4"},
          {tema:"7",title:"Lalabumers visitan al pediatra",img:"lalabumers_visitan_al_pediatra.png",url:"https://www.lalabumapp.com/descargas/videos/lalabumers_visitan_al_pediatra.mp4"},
          {tema:"8",title:"Mi mami es la mejor",img:"mi_mami_es_la_mejor.png",url:"https://www.lalabumapp.com/descargas/videos/Mi_mami_es_la_mejor.mp4"},
          {tema:"9",title:"La expresión de emociones básicas",img:"expresion_emociones.png",url:"https://lalabumapp.com/descargas/videos/expresion_de_emociones.mp4"},
          {tema:"10",title:"Tareas en casa",img:"tareas_casa.png",url:"https://lalabumapp.com/descargas/videos/tareas_en_casa.mp4"},
          {tema:"11",title:"Goldstar Nicejob",img:"video_goldstarNicejob.png",url:"https://lalabumapp.com/descargas/videos/Video_Goldstar_Nicejob.mp4"},
          {tema:"12",title:"Ponemos la mesa",img:"ponemos_la_mesa.png",url:"https://lalabumapp.com/descargas/videos/ponemos_la_mesa.mp4"},
          {tema:"13",title:"La puntualidad",img:"puntualidad.png",url:"https://lalabumapp.com/descargas/videos/puntualidad.mp4"},
          {tema:"14",title:"Lily y su bicicleta nueva",img:"lily_en_bicicleta.png",url:"https://lalabumapp.com/descargas/videos/lily_y_su_bicicleta.mp4"},
          {tema:"15",title:"Respiración de abeja",img:"respiracion_abeja.png",url:"https://lalabumapp.com/descargas/videos/respiracion_abeja.mp4"},
          {tema:"16",title:"Botana chatarra por saludable",img:"comida_saludable.png",url:"https://lalabumapp.com/descargas/videos/comida_chatarra.mp4"},
          {tema:"17",title:"Tomar decisiones - Lalo y su perro",img:"cuento_lalo_y_su_perro.png",url:"https://lalabumapp.com/descargas/videos/tomar_decisiones.mp4"},
          {tema:"18",title:"Funciones de las autoridades",img:"autoridades.png",url:"https://lalabumapp.com/descargas/videos/funcion_de_autoridades.mp4"},
          {tema:"19",title:"Beneficios del cuidado de los árboles",img:"cuidar_arboles.png",url:"https://lalabumapp.com/descargas/videos/cuidar_arboles.mp4"},
          {tema:"20",title:"Separar la basura",img:"separar_la_basura.png",url:"https://lalabumapp.com/descargas/videos/separar_basura.mp4"},
          {tema:"21",title:"Ser cortés",img:"se_cortes.png",url:"https://lalabumapp.com/descargas/videos/Cuento_Ser_Cortes.mp4"},
          {tema:"22",title:"Cuidando la plantita",img:"cuiidando_la_plantita.png",url:"https://lalabumapp.com/descargas/videos/cuidando_la_plantita.mp4"},
          {tema:"23",title:"Asi doblo mi ropa",img:"doblo_mi_ropa.png",url:"https://lalabumapp.com/descargas/videos/doblo_mi_ropa.mp4"},
          {tema:"24",title:"Hábitos de higiene",img:"habitos_higiene.png",url:"https://lalabumapp.com/descargas/videos/habitos_higiene.mp4"},
          {tema:"25",title:"Rutina para hacer ejercicio",img:"ejercicios.png",url:"https://lalabumapp.com/descargas/videos/ejercicio.mp4"},
          {tema:"26",title:"El plato del bien comer",img:"plato_bien_comer.png",url:"https://lalabumapp.com/descargas/videos/plato_del_bien_comer.mp4"},
          {tema:"27",title:"Sonidos ambientales",img:"sonidos_ambientales.png",url:"https://lalabumapp.com/descargas/videos/sonidos_ambientales.mp4"},
          {tema:"28",title:"El cuidado del agua",img:"cuidado_del_agua.png",url:"https://lalabumapp.com/descargas/videos/cuidado_del_agua.mp4"},
          {tema:"29",title:"Nos parecemos a alguien",img:"nos_parecemos.png",url:"https://lalabumapp.com/descargas/videos/nos_parecemos.mp4"},
          {tema:"30",title:"La familia",img:"lafamilia.png",url:"https://lalabumapp.com/descargas/videos/lafamilia.mp4"},
          {tema:"31",title:"Ser buen vecino",img:"buen_vecino.png",url:"https://lalabumapp.com/descargas/videos/ser_buen_vecino.mp4"},
          {tema:"32",title:"La isla de la basura", img:"isla_basura.png",url:"https://lalabumapp.com/descargas/videos/isla_basura.mp4"},
          {tema:"33",title:"Lalabumers Limpios", img:"lalabumers_limpios.png",url:"https://lalabumapp.com/descargas/videos/lalabumers_limpios.mp4"},
          {tema:"34",title:"Hacer lo correcto", img:"hacer_lo_correcto.png",url:"https://lalabumapp.com/descargas/videos/hacer_lo_correcto.mp4"},
          {tema:"35",title:"Culturas en el mundo", img:"culturas.png",url:"https://lalabumapp.com/descargas/videos/Culturas_del_mundo.mp4"},
          {tema:"36",title:"Cómo cuido el medio ambiente", img:"cuidado_medio_ambiente.png",url:"https://lalabumapp.com/descargas/videos/cuidado_medio_ambiente.mp4"},
          {tema:"37",title:"El cuidado de las mascotas", img:"mascotas.png",url:"https://lalabumapp.com/descargas/videos/cuidado_mascotas.mp4"},
          {tema:"38",title:"Medidas se seguridad", img:"medidas_seguridad.png",url:"https://lalabumapp.com/descargas/videos/medidas_seguridad.mp4"},
          {tema:"39",title:"Lalo y la hora de comer", img:"la_hora_de_comer.png",url:"https://lalabumapp.com/descargas/videos/Lalo_y_la_hora_de_comer.mp4"},
          {tema:"40",title:"Que gano al compartir", img:"compartir.png",url:"https://lalabumapp.com/descargas/videos/compartir.mp4"},
          {tema:"41",title:"Semáforo de las emociones", img:"semaforo_emociones.png",url:"https://lalabumapp.com/descargas/videos/semaforo_emociones.mp4"},
          {tema:"42",title:"Me das agua por favor", img:"me_das_agua_porfavor.png",url:"https://lalabumapp.com/descargas/videos/VideoCuento_me_das_agua_por_favor.mp4"},
          {tema:"43",title:"Que hacer y como reaccionar si me pierdo", img:"reaccionar_si_me_pierdo.png",url:"https://lalabumapp.com/descargas/videos/reaccionar_si_me_pierdo.mp4"},
          {tema:"44",title:"Capacidades diferentes", img:"capacidades_diferentes.png",url:"https://lalabumapp.com/descargas/videos/capacidades_diferentes.mp4"},
          {tema:"45",title:"Objetos tirados", img:"objetos_tirados.png",url:"https://lalabumapp.com/descargas/videos/objetos_tirados.mp4"},
          {tema:"46",title:"Indicaciones en el carro o al cruzar la calle", img:"indicaciones.png",url:"https://lalabumapp.com/descargas/videos/indicaciones.mp4"},
          {tema:"47",title:"Lo presto y tambien lo regreso", img:"presto_y_regreso.png",url:"https://lalabumapp.com/descargas/videos/prestar_devolver.mp4"},
          {tema:"48",title:"Yo soy feliz", img:"soy_feliz.png",url:"https://lalabumapp.com/descargas/videos/yo_soy_feliz.mp4"},
          {tema:"49",title:"Paseando en los pasillos de la jugueteria", img:"jugueteria.png",url:"https://lalabumapp.com/descargas/videos/paseando_por_la_jugueteria.mp4"},
          {tema:"50",title:"Las profesiones y oficios", img:"profesiones_oficios.png",url:"https://lalabumapp.com/descargas/videos/Profesiones_y_oficios.mp4"},
          {tema:"51",title:"Espero mi turno", img:"espero_turno.png",url:"https://lalabumapp.com/descargas/videos/Espero_mi_turno.mp4"},
          {tema:"52",title:"El domingo de Shanty", img:"domingo_shanty.png",url:"https://lalabumapp.com/descargas/videos/Cuento_El_Domingo_de_Shanty.mp4"},
          {tema:"53",title:"La ONU y los derechos de los niños", img:"onu.png",url:"https://lalabumapp.com/descargas/videos/ONU.mp4"},
          {tema:"54",title:"Los horarios de Lucy", img:"horarios_de_lucy.png",url:"https://lalabumapp.com/descargas/videos/Los_horarios_de_Lucy.mp4"},
          {tema:"55",title:"Video tutorial Regalo amor a mamá 3k", img:"regalo_a_mama.png",url:"https://lalabumapp.com/descargas/videos/regalo-para-mama.mp4"},
          {tema:"56",title:"Capitan Mantarraya", img:"capitan_mantarraya.png",url:"https://lalabumapp.com/descargas/videos/Capitan_Mantarraya.mp4"},
          {tema:"57",title:"Formas de ser generoso", img:"ser_generoso.png",url:"https://lalabumapp.com/descargas/videos/ser-generoso.mp4"},
          {tema:"58",title:"Uso del internet", img:"uso_internet.png",url:"https://lalabumapp.com/descargas/videos/uso-internet.mp4"},
          {tema:"59",title:"Ejercicios del avión de la tranquilidad", img:"avion_tranquilidad.png",url:"https://lalabumapp.com/descargas/videos/avion_tranquilidad.mp4"},
          {tema:"60",title:"Día del niño", img:"dia_del_nino.png",url:"https://lalabumapp.com/descargas/videos/diadelnino.mp4"},
        ]
      }
    },
    computed: {
      filterVideos: function(){
        if (this.searchvideo=="") {
          return this.videos
        }else{
          return this.videos.filter((video)=>{
            var expresion = new RegExp(this.searchvideo,"i")
            return video.title.match(expresion)
          })
        }      
      }
  },
  methods:{
    
    mostrar: function(cap) {
            this.$refs.repo.setContent(cap)
            this.dialog=true
            //this.dialog_capacitacion=cap    
        },   

      close: function(){
          this.dialog=false
      }
      
  }
    
  }
</script>


<style scoped >
 .temavideo{
    background-color:#B22F4A; 
    color: white;
    font-family: "Poppins";
    font-weight: 500;  
  }

/*@media (min-width: 1200px)and (max-width: 1300px){
  input[type=text] {
    background-color:white;
    width:80%;
    font-size:18px;
    height:78%;
    padding: 12px 20px;
    border-radius:6px;
    float:right;
    margin-right: -80px;
  }

  .imgbuscador{
    position:absolute;
    margin-left: 125px;
  }
}*/

/*@media (min-width: 1300px)and (max-width: 1800px){
  input[type=text] {
    background-color:white;
    width:80%;
    font-size:18px;
    height:78%;
    padding: 12px 20px;
    border-radius:6px;
    float:right;
    margin-right: -90px;
  }

  .imgbuscador{
    position:absolute;
    margin-left: 150px;
  }
}*/


/*@media (min-width: 1800px) and (max-width: 2000px){
  input[type=text] {
    background-color:white;
    width:80%;
    font-size:18px;
    height:70%;
    padding: 12px 20px;
    border-radius:6px;
    float:right;
    margin-right: -95px;
  }

  .imgbuscador{
    position:absolute;
    margin-left: 155px;
  }
}*/

/*@media (min-width: 2000px){
  input[type=text] {
    background-color:white;
    width:80%;
    font-size:18px;
    height:65%;
    padding: 12px 20px;
    border-radius:6px;
    float:right;
    margin-right: -135px;
  }

  .imgbuscador{
    position:absolute;
    margin-left: 245px;
  }
}*/


  
@media (min-width: 750px){
  .temavideo{
    font-size: 1.5vw;   
  }

  }

  /*@media (min-width: 750px) and (max-width: 1000px){
    input[type=text] {
    background-color:white;
    width:90%;
    font-size:18px;
    height:85%;
    padding: 12px 20px;
    border-radius:6px;
    margin-left: -50px;
    
  }


  .imgbuscador{
    position:absolute;
    margin-left: -106px;
  }
  }*/

  /*@media (min-width: 1000px) and (max-width: 1200px){
     input[type=text] {
    background-color:white;
    width:90%;
    font-size:18px;
    height:85%;
    padding: 12px 20px;
    border-radius:6px;
    float: right;
    margin-right: -65px;
    
  }


  .imgbuscador{
    position:absolute;
    margin-left: 40px;
  }
  }*/

  @media (min-width: 300px) and (max-width: 750px){
    .temavideo{
    font-size: 4.5vw;     
  }
  /*input[type=text] {
    background-color:white;
    width:60%;
    font-size:18px;
    height:100%;
    padding: 12px 20px;
    border-radius:6px;
    top:-30px;
    margin-left: 50px;
  }

  .imgbuscador{
    position:absolute;
    margin-left: -8px;
    
  }*/

  }

.playvideo:hover {
  transform: scale(1.2); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
  }

  .center {
  position:absolute; 
  top: 50%;
  left:50%;
  margin-top: -50px; 
  margin-left: -30px;
  }


.downloadfile{
  position: absolute; bottom: -15px; right: -10px;
  width: 30px;
}
</style>
